import React from "react"
import ActivityFeedEventSearchResult from "../../../state/search/Dto"
import { injectIntl, FormattedDate, FormattedTime } from "react-intl"
import ActivityFeedEventConversationMessageComponent from "./ActivityFeedEventConversationMessageComponent"
import ActivityFeedEventDocumentSignedComponent from "./ActivityFeedEventDocumentSignedComponent"
import { ACTIVITY_FEED_EVENT_TYPE } from "../../../state/activity-feed/ActivityFeedEventType"
import ActivityFeedEventPaymentCapturedComponent from "./ActivityFeedEventPaymentCapturedComponent"
import ActivityFeedEventInvoiceSyncRequest from "./ActivityFeedEventInvoiceSyncRequest"
import ActivtiyFeedEventQuoteStatusUpdated from "./ActivityFeedEventQuoteStatusUpdatedComponent"
import ActivityFeedEventIcon from "./ActivityFeedEventIconComponent"
import { Intl } from "../../../state/helpers/IntlProps"

type Props = {
    intl: Intl,
    activity: ActivityFeedEventSearchResult,
}

const ActivityFeedEventComponent = (props: Props) => {
    const renderActivityFeedEventContent = (() => {
        switch (props.activity.getActivityType()) {
        case ACTIVITY_FEED_EVENT_TYPE.SMS_RECEIVED:
        case ACTIVITY_FEED_EVENT_TYPE.CHAT_MESSAGE_RECEIVED:
            return <ActivityFeedEventConversationMessageComponent
                activity={props.activity} />
        case ACTIVITY_FEED_EVENT_TYPE.DOCUMENT_SIGNED:
            return <ActivityFeedEventDocumentSignedComponent
                activity={props.activity} />
        case ACTIVITY_FEED_EVENT_TYPE.QUOTE_STATUS_APPROVED:
        case ACTIVITY_FEED_EVENT_TYPE.QUOTE_STATUS_DECLINED:
            return <ActivtiyFeedEventQuoteStatusUpdated
                activity={props.activity} />
        case ACTIVITY_FEED_EVENT_TYPE.QUOTE_PAYMENT_CAPTURED:
        case ACTIVITY_FEED_EVENT_TYPE.ORDER_PAYMENT_CAPTURED:
        case ACTIVITY_FEED_EVENT_TYPE.INVOICE_PAYMENT_CAPTURED:
            return <ActivityFeedEventPaymentCapturedComponent
                activity={props.activity} />
        case ACTIVITY_FEED_EVENT_TYPE.INVOICE_SYNC_RECEIVED:
            return <ActivityFeedEventInvoiceSyncRequest
                activity={props.activity} />
        default:
            return
        }
    })

    return (

        <div className="feed-item" key={props.activity.getId()}>

            <div className={"row"}>
                <div className="date">
                    <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        weekday='long'
                        value={new Date(props.activity.getCreatedAt())}
                    />
                    &nbsp;-&nbsp;
                    <FormattedTime
                        value={new Date(props.activity.getCreatedAt())}
                    />
                </div>
            </div>

            <div className={"row has-ui-module"}>
                <div className={"col-12 ui-module"}>

                    <div className={"row undefined"}>

                        <div className={"col-12 d-flex align-items-center"} >
                            <div className={"mr-1"}>
                                <h3 className={"m-0"}>
                                    <ActivityFeedEventIcon activity={props.activity} />
                                </h3>
                            </div>
                            <div className={"col flex-grow-1"}>
                                {renderActivityFeedEventContent()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default injectIntl(ActivityFeedEventComponent)


// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/components/ActivityFeedEventComponent.tsx